import { useEffect } from "react";
import { useHistory, useLocation } from "react-router";

import marketingParamsStorage from "../../../../lib/MarketingParams/MarketingParamsStorage";

function MarketingParamsProvider() {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const { changed, capturedKeys } = marketingParamsStorage.captureFromSearch(
      location.search
    );

    if (!changed || capturedKeys.length === 0) {
      return;
    }

    const nextSearch = marketingParamsStorage.stripCapturedParamsFromSearch(
      location.search,
      capturedKeys
    );

    history.replace({
      pathname: location.pathname,
      search: nextSearch,
      hash: location.hash
    });
  }, [history, location.pathname, location.search, location.hash]);

  return null;
}

export default MarketingParamsProvider;
